<template>
  <div class="service-nww-prg-alarm">
    <p>
      {{ $t('messages.alarms.serviceNWWPrgAlarm.description') }}
    </p>

    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <alert-handler-list
      class="g-alarm-handler__row"
      :list="alarmData.list"
    />

    <div class="g-alarm-handler__row">
      <!-- <h3 class="g-text g-text--center">
        {{ $t('messages.alarms.suggestion') }}
      </h3>
      <p>{{ $t('messages.alarms.serviceNWWPrgAlarm.suggestion') }}</p> -->

      <slot v-if="store.getData('user.access.programEdit')">
        <p>{{ $t('messages.alarms.serviceNWWPrgAlarm.label') }}</p>

        <div class="g-alarm-handler__row g-text g-text--center">
          <button
            type="button"
            class="g-btn g-btn--rounded g-btn--blue"
            @click.stop="$router.push('/programs')"
          >
            {{ $tc('messages.sharedTexts.programs.program', 0) }} <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </button>
        </div>
      </slot>
      <p
        v-else
        class="g-alarm-handler__highlight g-alarm-handler__highlight--yellow"
      >
        <strong>{{ $t('messages.alarms.attention') }}</strong>: {{ $t('messages.alarms.serviceNWWPrgAlarm.attention') }}
      </p>
    </div>
  </div>
</template>

<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'

export default {
  name: 'ServiceNWWPrgAlarm',
  mixins: [ServiceAlarm]
}
</script>
